import { useApolloClient } from '@graphcommerce/graphql'
import { useFormGqlMutation } from '@graphcommerce/react-hook-form'
import { useRouter } from 'next/router'
import React, { useState } from 'react'
import { SignOutFormDocument } from '@graphcommerce/magento-customer/components/SignOutForm/SignOutForm.gql'
import Loading from '../icons/Loading'
import { useCompareListUidCreate } from '@graphcommerce/magento-compare'



export function SignOutForm({ children }: { children: React.ReactNode }) {
  const router = useRouter()
  const client = useApolloClient();
  const [loading, setLoading] = useState(false);
  const { handleSubmit, formState, error } = useFormGqlMutation(
    SignOutFormDocument,
    {
      onComplete: async () => {
        setLoading(false);
        await client.clearStore()
        await router.push('/')
        router.reload();
      },

    },
    { errorPolicy: 'all' },
  )
  const submitHandler = handleSubmit(() => { })



  return (
    <form onSubmit={(e) => {
      setLoading(true);
      submitHandler(e)
    }} noValidate>
      {loading ? <Loading width={18} height={18} /> : children}
    </form>
  )
}
